/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommercialEditItemDto } from './CommercialEditItemDto';
import type { CreateSalesOrderChargeDto } from './CreateSalesOrderChargeDto';
export type UpdateSalesOrderCommercialDto = {
  /**
   * Customer profile ID. Null clears the customer.
   */
  customerId?: Record<string, any> | null;
  /**
   * External manual invoice flag (internal tracking only)
   */
  hasInvoice?: boolean;
  /**
   * Seller of record (createdBy). Changing to a different seller requires orders.sales-management.change_seller.
   */
  createdById?: string;
  /**
   * When true, server stamps commercial saleDate to confirmation time (same as create with "Fecha actual"). Prefer this over sending a client clock ISO.
   */
  useCurrentSaleDate?: boolean;
  /**
   * Commercial sale date/time (ISO 8601) for an explicit custom date. Cannot be in the future. Ignored when useCurrentSaleDate is true.
   */
  saleDate?: string;
  /**
   * Line pricing updates. Must include every existing item when provided.
   */
  items?: Array<CommercialEditItemDto>;
  /**
   * Full replacement of order-level charges. Empty array removes all charges.
   */
  charges?: Array<CreateSalesOrderChargeDto>;
  /**
   * Client-computed subtotal before discounts (validated server-side)
   */
  subtotal?: number;
  /**
   * Client-computed extra charges total (validated server-side)
   */
  extraChargesTotal?: number;
  /**
   * Client-computed grand total (validated server-side)
   */
  totalAmount?: number;
  /**
   * Required when any line finalPrice is 0
   */
  confirmZeroSale?: boolean;
  /**
   * Discount scope after the adjustment
   */
  discountScope?: UpdateSalesOrderCommercialDto.discountScope;
};
export namespace UpdateSalesOrderCommercialDto {
  /**
   * Discount scope after the adjustment
   */
  export enum discountScope {
    PER_ITEM = 'PER_ITEM',
    PER_ORDER = 'PER_ORDER',
  }
}
